import { GroupSquares } from 'global/wrappers/GroupSquares'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import React, { useState } from 'react'
import { Button, Icon, Label, Popup } from 'semantic-ui-react'

export const SquaresOptions = ({
  title,
  caption,
  currentValue,
  menuGroup,
  position = 'bottom left'
}) => {

  const [isOpen, setIsOpen] = useState(false)

  const btn = <Button
    labelPosition='right'
    content={caption}
    size='mini'
    color={'blue'}
    icon={'arrow right'}
    onClick={() => { setIsOpen(true) }}
  />

  // const trigger = <Label
  //   size='tiny'
  //   style={{ margin: '.5em', cursor: 'pointer' }}
  //   color='blue'
  //   onClick={(e) => {
  //     setIsOpen(true)
  //   }}
  // >
  //   {caption}
  //   <Icon name='angle right' style={{ marginLeft: '1em' }} />
  // </Label>

  const fnAlt = (item) => {
    switch (item) {
      default:
        return <Icon name='arrow right' color='blue' />
    }
  }

  const fnIcon = (item) => {
    switch (item) {

    }
    return 'cog'
  }

  const content_currentGroup = (cg) => {
    const { key } = cg ?? {}
    const items = menuGroup?.[key]?.items
    const hoc = (item) => {
      if (item.oc && item.opts) {
        setIsOpen(false)
        item.oc(null, item.opts)
      } else if (item.oc) {
        item.oc()
      }
    }
    return <ItemMenuSquares menuItems={items} imsType={_imsTypes.inline} onClick={hoc} />
  }

  const content = () => <GroupSquares
    menuItems={_.keys(menuGroup)}
    fnCurrentGroup={content_currentGroup}
    fnAlt={fnAlt}
    fnIcon={fnIcon}
    caption={caption}
    imsType={_imsTypes.inline}
    // noHeader={true}
    noItemIcon={true}
  />

  return <Popup
    content={<div style={{ display: 'flex', flexDirection: 'column', gap: '.5em', maxHeight: '30vh', overflowY: 'auto', padding: 0 }}>{content()}</div>}
    on='click'
    pinned
    position={position}
    basic
    size='tiny'
    style={{ backgroundColor: 'var(--off-black-4)', color: 'white', borderColor: 'var(--off-black-5)', width: '250px', padding: '.1em' }}
    trigger={btn}
    open={isOpen}
    onOpen={() => setIsOpen(true)}
    onClose={() => setIsOpen(false)}
    closeOnDocumentClick
    flowing
  />


}
